import { DEFAULT_LANG } from '@/constants'
import { useCurrentLanguage } from '@/hooks/usei18n'
import { useCallback } from 'react'

export const useI18nText = () => {
  const selectedLang = useCurrentLanguage().languageType

  const getI18nText = useCallback(
    (langMap) => {
      // 返回对应语种的值，使用英文兜底
      return typeof langMap === 'object' && langMap ? langMap[selectedLang] || langMap[DEFAULT_LANG] : ''
    },
    [selectedLang]
  )

  return {
    getI18nText,
    selectedLang,
  }
}

/**
 * 复制字符串到粘贴板
 * todo:
 * @param copyText
 */
export const handleCopy = (copyText: string) => {
  if (navigator.clipboard) {
    // clipboard api 复制
    navigator.clipboard.writeText(copyText)
  } else {
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', copyText)
    input.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
    }
    document.body.removeChild(input)
  }
}

/** 判断URL格式是否错误 */
export const isUrlFormatValid = (url: string) => {
  if (!url) return true
  return /^((http:|https:)+(\/\/)[^\s]*?(([A-Za-z0-9]+-[A-Za-z0-9]+|[A-Za-z0-9]+)\.))+([a-z]+)[/?:]?.*$/.test(url)
}

/**
 * @param prefix 唯一ID前缀
 * @returns
 */
export const uuid = (prefix = '') => prefix + Math.random().toString(36).slice(-8)
